/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminthreads_Nomatch2Inputs */

const zh_adminthreads_nomatch2 = /** @type {(inputs: Adminthreads_Nomatch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到匹配的对话`)
};

const en_adminthreads_nomatch2 = /** @type {(inputs: Adminthreads_Nomatch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matching conversations found`)
};

const es_adminthreads_nomatch2 = /** @type {(inputs: Adminthreads_Nomatch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron conversaciones`)
};

/**
* | output |
* | --- |
* | "No matching conversations found" |
*
* @param {Adminthreads_Nomatch2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminthreads_nomatch2 = /** @type {((inputs?: Adminthreads_Nomatch2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminthreads_Nomatch2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminthreads_nomatch2(inputs)
	if (locale === "en") return en_adminthreads_nomatch2(inputs)
	return es_adminthreads_nomatch2(inputs)
});
export { adminthreads_nomatch2 as "adminThreads_noMatch" }